import { createIcon } from '@chakra-ui/icons';

export const CalendarClock = createIcon({
  displayName: 'CalendarClock',
  viewBox: '0 0 10 10',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <g id="opening-times 1" clipPath="url(#clip0_1629_7276)">
        <g id="Group">
          <path
            id="Vector"
            d="M4.30125 8.75H1.25V3.75H8.75V4.30125C9.22421 4.48755 9.65115 4.7768 10 5.14813V2.5C10 2.33424 9.93415 2.17527 9.81694 2.05806C9.69973 1.94085 9.54076 1.875 9.375 1.875H8.125V0.625C8.125 0.45924 8.05915 0.300269 7.94194 0.183058C7.82473 0.065848 7.66576 0 7.5 0C7.33424 0 7.17527 0.065848 7.05806 0.183058C6.94085 0.300269 6.875 0.45924 6.875 0.625V1.875H3.125V0.625C3.125 0.45924 3.05915 0.300269 2.94194 0.183058C2.82473 0.065848 2.66576 0 2.5 0C2.33424 0 2.17527 0.065848 2.05806 0.183058C1.94085 0.300269 1.875 0.45924 1.875 0.625V1.875H0.625C0.45924 1.875 0.300269 1.94085 0.183058 2.05806C0.065848 2.17527 0 2.33424 0 2.5L0 9.375C0 9.54076 0.065848 9.69973 0.183058 9.81694C0.300269 9.93415 0.45924 10 0.625 10H5.14813C4.7768 9.65115 4.48755 9.22421 4.30125 8.75Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M7.5 5C7.00555 5 6.5222 5.14662 6.11108 5.42133C5.69995 5.69603 5.37952 6.08648 5.1903 6.54329C5.00108 7.00011 4.95157 7.50277 5.04804 7.98773C5.1445 8.47268 5.3826 8.91814 5.73223 9.26777C6.08187 9.6174 6.52732 9.8555 7.01228 9.95196C7.49723 10.0484 7.9999 9.99892 8.45671 9.8097C8.91353 9.62048 9.30397 9.30005 9.57868 8.88893C9.85338 8.4778 10 7.99445 10 7.5C10 6.83696 9.73661 6.20107 9.26777 5.73223C8.79893 5.26339 8.16304 5 7.5 5ZM8.75 7.96875H7.5C7.37568 7.96875 7.25645 7.91936 7.16855 7.83146C7.08064 7.74355 7.03125 7.62432 7.03125 7.5V6.25C7.03125 6.12568 7.08064 6.00645 7.16855 5.91854C7.25645 5.83064 7.37568 5.78125 7.5 5.78125C7.62432 5.78125 7.74355 5.83064 7.83146 5.91854C7.91937 6.00645 7.96875 6.12568 7.96875 6.25V7.03125H8.75C8.87432 7.03125 8.99355 7.08064 9.08146 7.16854C9.16937 7.25645 9.21875 7.37568 9.21875 7.5C9.21875 7.62432 9.16937 7.74355 9.08146 7.83146C8.99355 7.91936 8.87432 7.96875 8.75 7.96875Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1629_7276">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
